import React, { useEffect, useState } from 'react'
import * as Styled from './Dropdown.styles'

const Dropdown = ({ placeholderText = '', options, ...rest }) => (
  <>
    <Styled.Dropdown
      {...rest}
      isSearchable
      options={options}
      placeholder={placeholderText}
      styles={{
        // Fixes the overlapping problem of the component
        // This method comes straight from their docs
        menu: (provided) => ({
          ...provided,
          zIndex: 26,
        }),
      }}
    />
  </>
)

const DropdownWrapper = (props) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [setMounted])

  return mounted && <Dropdown {...props} />
}

export default DropdownWrapper
